module.exports = __webpack_public_path__ + "img/logo_parque.5d719024.svg";